import axios from "axios";
import { API } from "../../../backend";
import authHeader from "../../auth-header"

const getquote = (id)=> {
	return axios.get(API + "contracts/quotesingleview/"+id+"/" ,{ headers: authHeader() })}

  const checkquotestatus = (id)=> {
	return axios.get(API + "contracts/quotecheck/"+id+"/" ,{ headers: authHeader() })}

const addquote = (contract,termination_type, termination_date,
) => {
  return axios.post(API + "contracts/create-quote/", {
    contract,
    termination_type,
    termination_date,

  },{headers: authHeader(),});
};
const editquote = (
  state,
  contract,
  termination_type,
  termination_date,
    ) => {
      return axios.post(API + "contracts/edit-quote/" +state+"/", {
         
        contract,
        termination_type,
        termination_date,
  
      },{headers: authHeader(),});
    };
const editquoteline = (
  state,
  quote,
  payoff_fee,
  payOff_amount,
  outstanding_ar,
  unbilled_ar,
  computed_payoff,
  termination_type

    ) => {
      return axios.post(API + "contracts/edit-quoteline/" +state+"/", {
        quote,
        payoff_fee,
        payOff_amount,
        outstanding_ar,
        unbilled_ar,
        computed_payoff,
        termination_type
  
      },{headers: authHeader(),});
    };

    const quoteprocess = (
  state,

    ) => {
      return axios.post(API + "contracts/quoteprocess/" +state+"/", {
      },{headers: authHeader(),});
    };

const Quoteservice = {
    addquote,
    getquote,
    editquote,
    editquoteline,
    quoteprocess,
    checkquotestatus

  };
  export default Quoteservice;